import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

import { ReportContentItem } from '../../models/run.model';
import { sortReportContentItems } from '../../utils/report-item-columns.util';

@Component({
  selector: 'app-report-content-select',
  template: `
    <div class="bpx-control">
      <span class="bpx-control__label">Assay</span>
      <mat-form-field class="bpx-field" appearance="outline">
        <mat-select
          aria-label="Assay"
          [value]="selectedId()"
          [disabled]="disabled()"
          (selectionChange)="onSelectionChange($event)">
          @for (option of options(); track option.id) {
            <mat-option [value]="option.id">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  `,
  styleUrl: './report-content-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportContentSelectComponent {
  readonly items = input<ReportContentItem[]>([]);
  readonly selectedId = input<string | null>(null);
  readonly refKitLot = input<string>('');
  readonly disabled = input(false);
  readonly selectionChange = output<MatSelectChange>();

  readonly options = computed(() => sortReportContentItems(this.items() ?? [], this.refKitLot() ?? '').map(item => ({
    id: item.reportContentItemId ?? '',
    label: this.buildLabel(item)
  })));

  onSelectionChange(event: MatSelectChange): void {
    this.selectionChange.emit(event);
  }

  private buildLabel(item: ReportContentItem): string {
    return `${this.formatValue(item.runId)} - ${this.formatValue(item.assay)} - ${this.formatValue(item.lot)} - ${this.formatValue(item.antigenLoadLn)}`;
  }

  private formatValue(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value);
  }
}
